export function onEnterKeyPress(key, callback) {
    if (key === 'Enter') {
        callback();
    }
}